import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  project: generateApiPath({ prefix: AuthLevel.PUBLIC, name: 'project' }),
}

export { paths }
